<script setup lang="ts">
import { Icon } from '@iconify/vue';
import { appLinks } from '@/layouts/data/headerConfig';
</script>

<template>
  <v-row>
    <v-col
      v-for="item in appLinks"
      :key="item.title"
      cols="12"
      md="6"
    >
      <router-link
        :to="item.href"
        class="d-flex align-center text-decoration-none"
      >
        <v-avatar
          size="45"
          :color="'light' + item.color"
          rounded="md"
        >
          <Icon
            :icon="item.icon"
            height="24"
            :class="`text-${item.color}`"
          />
        </v-avatar>
        <div class="ml-3">
          <h6 class="mb-1">
            {{ item.title }}
          </h6>
          <p class="text-subtitle-2 text--secondary">
            {{ item.subtext }}
          </p>
        </div>
      </router-link>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
.text-decoration-none {
  text-decoration: none;
}

h6 {
  margin: 0;
}
</style>
